/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 11:56:52
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-07-20 16:08:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/index.tsx
 */
import Layout from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import React from 'react';
import Info from './Info';
import Tags from './Tags';
import Image from './Images';
import Price from './Pricing';
import Stock from './Stock';
import Available from './Availability';
import Denomination from './Denomination';
import ProductDetail from './ProductDetail';
import CardSetting from './GiftCardSetting';
import SalesChannelUsage from './SalesChannelUsage';
//import Attributes from './Attribute';
import HOC from './EditorHOC';
import RouteBlock from './RouteBlock';
import {
  getHasModified,
  validation,
  getState,
  submitProduct,
  getLoaded,
  //getName-,
  updateEssentialData,
  getUuid,
  fetchProduct,
  resetData,
  duplicateProduct,
  getProductType,
  getLastModified,
  getProductName,
  onProductLoad,
  onHasModified,
  getProductIsSold,
} from './slice';
import { convertDataFromReduxToServer } from './tools';
import { deleteProd } from 'src/pages/ProductEditor/tools/commonRequests';
import { EnumProductType } from 'src/types/common/product';
// import { Form } from 'src/components/Antd';
import { NEW, NULL } from 'src/tools/constant';
// import { useParams } from 'react-router-dom';
// import { useDispatch } from 'react-redux';
import { getProduct } from '@/src/request/product/product';

import { storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
} from 'src/types/common/resources';
import { isUserValid } from 'src/tools/getUserInfo';
import { EPermissionSource } from 'src/types/common/resources';
import { Skeleton } from '@/src/components/Antd';

const VirtualProductEditor = (props) => {
  // const [form] = Form.useForm();

  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  const {
    topLeft,
    topRight,
    hasModified,
    type,
    form,
    params,
    avaAtt,
    handleOnAvaAttOptionsChange,
    hasBeenSold,
    loaded,
  } = props;

  const isService = type === EnumProductType.Service;

  const giftCardDisabled = hasBeenSold && !isService;

  const Child = React.useMemo(() => {
    if (isService) {
      return [
        {
          element: Info,
          id: 'ProductInfo',
          p: {
            form,
            formName: 'VirtualProductEditor',
            avaAtt,
            disabled: !canEdit,
          },
        },
        // {
        //   element: Attributes,
        //   id: 'ProductInfo',
        //   p: {
        //     form,
        //     productUuid:
        //       params.uuid === NEW || params.uuid === NULL
        //         ? null
        //         : params.uuid,
        //     avaAtt,
        //     onAttOptionsChange: handleOnAvaAttOptionsChange,
        //     disabled: !canEdit,
        //   },
        // },
        {
          element: ProductDetail,
          id: 'ProductDetail',
          p: {
            disabled: !canEdit,
          },
        },
        {
          element: Tags,
          id: 'Tags',
          p: {
            disabled: !canEdit,
          },
        },
        {
          element: Image,
          id: 'Image',
          p: {
            disabled: !canEdit,
          },
        },
        { element: Stock, id: 'Stock', p: { isService, disabled: !canEdit } },
        {
          element: Price,
          id: 'Price',
          p: {
            disabled: !canEdit,
            productUuid:
              params.uuid === NEW || params.uuid === NULL ? null : params.uuid,
          },
        },
        {
          element: Available,
          id: 'Availability',
          p: {
            disabled: !canEdit,
          },
        },
      ];
    }
    return [
      {
        element: Info,
        id: 'ProductInfo',
        p: {
          form,
          formName: 'VirtualProductEditor',
          disabled: !canEdit || giftCardDisabled,
        },
      },
      // {
      //   element: Attributes,
      //   id: 'ProductInfo',
      //   p: {
      //     disabled: !canEdit,
      //     form,
      //     productUuid: params.uuid === NEW ? null : params.uuid,
      //     avaAtt,
      //     onAttOptionsChange: handleOnAvaAttOptionsChange,
      //   },
      // },
      {
        element: CardSetting,
        id: 'CardSetting',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
      {
        element: Denomination,
        id: 'Denomination',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
      {
        element: Tags,
        id: 'Tags',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
      {
        element: Image,
        id: 'Image',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
      {
        element: SalesChannelUsage,
        id: 'SalesChannelUsage',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
      { element: Stock, id: 'Stock', p: { disabled: !canEdit, isService } },
      {
        element: Available,
        id: 'Availability',
        p: {
          disabled: !canEdit || giftCardDisabled,
        },
      },
    ];
  }, [isService, avaAtt, handleOnAvaAttOptionsChange, giftCardDisabled]);
  // const name = 'VirtualProductEditor';
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      {loaded ? (
        <Layout topLeft={topLeft} topRight={topRight} elements={Child} />
      ) : (
        <Skeleton loading={true} active />
      )}
    </React.Fragment>
  );
};
export default HOC(VirtualProductEditor, {
  getHasModified,
  getName: getProductName,
  validation,
  getState,
  convertDataFromReduxToServer,
  submit: submitProduct,
  deleteFunction: deleteProd,
  getLoaded,
  getUuid,
  fetchData: fetchProduct,
  resetData,
  duplicate: duplicateProduct,
  getProductType,
  getLastModified,
  updateEssentialData,
  onProductLoad,
  getProduct,
  formName: 'VirtualProductEditor',
  onHasModified,
  getProductIsSold,
});
